import moment from 'moment'

export default function convertToTwelveHourTime(twentyFourHourTime: string): string {
  return twentyFourHourTime ? moment(twentyFourHourTime, 'HH:mm').format('h:mm a') : ''
}
